export default function makeTextBreakable(text: string) {

    return text.replace("/", "/\u200B");
}